
<div class="bg-page-container d-flex flex-column justify-content-between h-100">
   <div class="mt-3 d-flex flex-column justify-content-center align-items-center" style="gap:3rem!important">
      <div class="fs-1 text-center">Southwestern Advantage</div>

      <div class="fs-2 text-center">Resources, Training, and Tools</div>

      <div class="d-flex flex-column justify-content-around ps-sm-2 btn-menu login gap-3">
         <button class="btn btn-site-secondary btn-lg border-white border-3 rounded-pill shadow text-nowrap fw-bold d-flex align-items-center gap-2"
                 (click)="navigateToLogin(b2cAuthority.usernameSignIn)">
            <span class="flex-grow-1">Sign in with Account Number</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
               <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
               <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1" />
            </svg>
         </button>

         <button class="btn btn-site-secondary btn-lg border-white border-3 rounded-pill shadow text-nowrap fw-bold d-flex align-items-center gap-2"
                 (click)="navigateToLogin(b2cAuthority.workAccountSignUpSignIn)">
            <span class="flex-grow-1 employee">Sign in with Work Account</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-badge" viewBox="0 0 16 16">
               <path d="M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
               <path d="M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492z" />
            </svg>
         </button>

      </div>

      <!--<div class="pt-3">
         <a href="{{trainingSiteUri}}">
            <img src="/assets/images/training-mode_button.png" class="training"/>
         </a>
      </div>-->

      <div class="pt-2 site-text-primary-training employees text-center">
         <strong>*Southwestern employees</strong> should <strong>Sign-in</strong> with
         <strong><em><u>Work Account</u></em></strong>
      </div>
   </div>

</div>

